import _toConsumableArray from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useState } from 'react';
import { judgeHideExtraProductEditInfoScheme } from '@jove-frontend/utils';
import { apiQuerySubTripartiteCooperationList } from '../../api/combineApi';
import { SubBrokerType } from '../../shared/generated';
export var useQuoteHearAboutUs = function useQuoteHearAboutUs(data) {
  var _useState = useState(false),
      showHearAboutUs = _useState[0],
      setShowHearAboutUs = _useState[1];

  var _useState2 = useState((data === null || data === void 0 ? void 0 : data.hearAboutSource) || ''),
      hearAboutSource = _useState2[0],
      setHearAboutSource = _useState2[1];

  var _useState3 = useState((data === null || data === void 0 ? void 0 : data.hearAboutCustomInput) || ''),
      hearAboutCustomInput = _useState3[0],
      setHearAboutCustomInput = _useState3[1];

  var _useState4 = useState([]),
      hearAboutList = _useState4[0],
      setHearAboutList = _useState4[1];
  /**
   * requests
   */


  var requestHearAboutList = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(promotionInfo, config) {
      var parentId, brokerId, _yield$apiQuerySubTri, _yield$apiQuerySubTri2, res;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!promotionInfo) {
                setHearAboutList([]);
              }

              parentId = promotionInfo === null || promotionInfo === void 0 ? void 0 : promotionInfo[(config === null || config === void 0 ? void 0 : config.brokerParentIdKey) || 'partnerParentId'];
              brokerId = promotionInfo === null || promotionInfo === void 0 ? void 0 : promotionInfo[(config === null || config === void 0 ? void 0 : config.brokerIdKey) || 'partnerId'];

              if (!parentId) {
                _context.next = 7;
                break;
              }

              setHearAboutList([{
                value: brokerId,
                label: promotionInfo[(config === null || config === void 0 ? void 0 : config.brokerNameKey) || 'brokerName']
              }]);
              _context.next = 14;
              break;

            case 7:
              if (!brokerId) {
                _context.next = 14;
                break;
              }

              _context.next = 10;
              return apiQuerySubTripartiteCooperationList({
                parentId: brokerId,
                offset: 0,
                limit: 1000,
                hideErrToast: true,
                sub_broker_type: SubBrokerType.BROKER
              });

            case 10:
              _yield$apiQuerySubTri = _context.sent;
              _yield$apiQuerySubTri2 = _slicedToArray(_yield$apiQuerySubTri, 1);
              res = _yield$apiQuerySubTri2[0];
              setHearAboutList([{
                value: brokerId,
                label: promotionInfo[(config === null || config === void 0 ? void 0 : config.brokerNameKey) || 'brokerName']
              }].concat(_toConsumableArray((res === null || res === void 0 ? void 0 : res.data) || [])));

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function requestHearAboutList(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  /**
   * methods
   */


  var judgeWhetherShowHearAboutUs = function judgeWhetherShowHearAboutUs(promotionInfo, config) {
    var _promotionInfo;

    return judgeHideExtraProductEditInfoScheme(promotionInfo === null || promotionInfo === void 0 ? void 0 : (_promotionInfo = promotionInfo[(config === null || config === void 0 ? void 0 : config.payloadKey) || 'payload']) === null || _promotionInfo === void 0 ? void 0 : _promotionInfo.product_scheme);
  };

  var hearAboutSourceChangeAction = function hearAboutSourceChangeAction(value) {
    setHearAboutSource(value);
  };

  var hearAboutCustomInputChangeAction = function hearAboutCustomInputChangeAction(value) {
    setHearAboutCustomInput(value);
  };

  return {
    showHearAboutUs: showHearAboutUs,
    setShowHearAboutUs: setShowHearAboutUs,
    judgeWhetherShowHearAboutUs: judgeWhetherShowHearAboutUs,
    hearAboutSource: hearAboutSource,
    hearAboutCustomInput: hearAboutCustomInput,
    hearAboutSourceChangeAction: hearAboutSourceChangeAction,
    hearAboutCustomInputChangeAction: hearAboutCustomInputChangeAction,
    requestHearAboutList: requestHearAboutList,
    hearAboutList: hearAboutList,
    setHearAboutList: setHearAboutList
  };
};